export const checkAttachmentType = (message, type) => {
    return message.attachments.some((attachment) => attachment.type === type);
};
